import React from 'react';
import { UI_Modal, UI_Modal_project, UI_Modal_success } from "../../UiComponents/index";
import { useNavigate } from "react-router-dom";

function SuccessModal(props) {
    const navigate = useNavigate();
    const {
        successModal, setSuccessModal, errorMesg, path, cloneMsg, setCloneMsg, deleteMsg
    } = props;

    const handleClose = () => {
        if (path) {
            setSuccessModal(false)
            navigate(path)
        } else {
            setSuccessModal(false)
            if(cloneMsg){
                setCloneMsg('')
            }
        }
    }
    const closeModal = () => {
        setSuccessModal(false)
        if(cloneMsg){
            setCloneMsg('')
        }
    }
    return (
        <>
            <UI_Modal_success
                isOpen={successModal}
                closeModal={() => closeModal()}
                title={cloneMsg ? cloneMsg : ""}
            >
                <div className="m-3 flex justify-center items-center text-white text-xl">
                    <div className="sccess_text text-center">
                        <h1 className='manrope-600 text-[26px] text-center'>
                            {errorMesg ? errorMesg : cloneMsg ? " " : deleteMsg ? deleteMsg : 'Project Created Successfully'}
                        </h1>
                    </div>
                </div>

                <div className="flex btn_container">
                    <button className="manrope-600 text-base text-white rounded-[10px] bg-[#4b3fcb] px-[22px] py-[4px] border-[1px] border-[#ffffff33]"
                        onClick={() => handleClose()}

                    >Close</button>
                </div>
            </UI_Modal_success>
        </>
    )
}

export default SuccessModal